import { observer } from 'mobx-react-lite';
import { PropsWithChildren, ReactElement } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorView } from '../../../views/errors/Error.View';
import { NotAuthorizedContainer } from './NotAuthorized.container';

export const ErrorsContainer = observer((props: PropsWithChildren): ReactElement => {
  return (
    <NotAuthorizedContainer>
      <ErrorBoundary fallback={<ErrorView />}>{props.children}</ErrorBoundary>
    </NotAuthorizedContainer>
  );
});
